import React, { useEffect, useState } from 'react';
import { App, Button, Form, Spin, Table, Tooltip, UploadProps } from 'antd';
import { IShowcase } from '../../../interfaces/interfaces';
import { EditableCell, EditableContext } from './EditableCell/EditableCell';
import {
  DeleteOutlined,
  ReloadOutlined,
  PlusCircleTwoTone,
  ExportOutlined,
} from '@ant-design/icons';
import { colorPrimary, defaultData } from '../../../../../../index';
import { Filters } from './Filters/Filters';
import { projectsApiService } from '../../../../../api/projects/projectsApiService';
import { useAppDispatch, useAppSelector } from '../../../../../core/redux';
import {
  getCodesOptions,
  getCreateXlsxData,
  getDataForCheckXPathTarget,
  getDataForTargetShowcase,
  getDataFromCDAForTarget,
  getInsensitiveTextSearch,
  getVerificationXPathDataTarget,
  getXlsxDataForTargetShowcase,
} from '../../../helpers/helpers';
import {
  initAttributeType,
  initDescriptionCode,
  initDescriptionNumber,
  tablesSlice,
} from '../../../TablesSlice';
import { notificationMessages, showNotification } from '../../../../usersPage/helpers/helpers';
import { getErrors } from '../../../../../helpers/helpers';
import { generateUniqueID } from 'web-vitals/dist/modules/lib/generateUniqueID';
import { XPathStructureTarget } from './XPathStructureTarget/XPathStructureTarget';
import Types from '../../../../../../types/types';

import s from './TargetShowcase.module.scss';
const { labelNames, initTabs } = Types;

interface EditableRowProps {
  index: number;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const EditableRow: React.FC<EditableRowProps> = ({ index, ...props }) => {
  const [form] = Form.useForm();
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  );
};

type EditableTableProps = Parameters<typeof Table>[0];

type ColumnTypes = Exclude<EditableTableProps['columns'], undefined>;
const { setTargetShowcaseData, setVisDeletedRow, setHasUnsavedChanges } = tablesSlice.actions;
export const TargetShowcase: React.FC = () => {
  const dispatch = useAppDispatch();
  const { notification } = App.useApp();
  const [deleteUpdateBtns, setDeleteUpdateBtns] = useState({ y: null, key: null, isNew: false });
  const [searchedText, setSearchedText] = useState('');

  // const [changedRows, setChangedRows] = useState([]);
  const [count, setCount] = useState(2);
  const [selectedKeys, setSelectedKeys] = useState<Array<number>>([]);
  const [xPathCodes, setXPathCodes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadRawXPath, setLoadRawXPath] = useState(false);
  const [drawerKey, setDrawerKey] = useState('');

  const {
    editableTable,
    targetShowcaseData: maxTargetShowcaseData,
    visDeletedRow,
    cdaRedactorTabs,
    activeXmlTab,
    maxData,
    hasUnsavedChanges,
  } = useAppSelector((state) => state.tablesSlice);

  const [
    getTargetShowcaseData,
    { data: targetShowcaseData, error: targetShowcaseError, isLoading: targetShowcaseLoading },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  ] = projectsApiService.useGetTargetShowcaseDataMutation({ id: editableTable.id });

  const {
    data: descriptionTargetShowcase,
    // error: descriptionTargetShowcaseError,
    // isLoading: descriptionTargetShowcaseLoading,
  } = projectsApiService.useGetDescriptionTargetShowcaseQuery({ skip: 0, limit: 1000 });
  const [
    getProjectXPathStructure,
    {
      data: projectXPathStructureData,
      error: projectXPathStructureError,
      isLoading: projectXPathStructureLoading,
    },
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
  ] = projectsApiService.useGetProjectXPathStructureMutation({ id: editableTable.id });
  const [
    getXlsxFileInfo,
    { data: fileInfoData, error: fileInfoError, isLoading: fileInfoLoading },
  ] = projectsApiService.useCreateXlsxDocForTargetShowcaseMutation();
  const [getXlsxFile] = projectsApiService.useGetXPathFileXlsxMutation();

  const [uploadXlsx, { data: parseXlsxData, error: parseXlsxError, isLoading: parseXlsxLoading }] =
    projectsApiService.useParseXlsxDocForTargetShowcaseMutation();
  const {
    data: attributeTypeOptions,
    // error: descriptionTargetShowcaseError,
    // isLoading: descriptionTargetShowcaseLoading,
  } = projectsApiService.useGetAttributeTypeOptionsQuery({ skip: 0, limit: 1000 });
  const [
    getCheckAllXPath,
    {
      data: checkAllXPathData,
      // isError: projectXPathStructureIsError,
      error: checkAllXPathError,
      // status: projectXPathStructureStatus,
      isLoading: checkAllXPathLoading,
    },
  ] = projectsApiService.useCheckAllXPathMutation();
  const exportProps: UploadProps = {
    name: 'file',
    showUploadList: false,
    customRequest: (e) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!e.file.type.match('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')) {
        showNotification(notification, 'Неверный формат файла', '', 'error');
        return;
      }
      const data = new FormData();
      data.append('file', e.file);
      uploadXlsx(data);
    },
  };
  const initDescription = // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    (descriptionTargetShowcase || []).find((d) => d.code === initDescriptionCode)?.id;
  const handleSetHasChanges = () => {
    const hasChanges = { ...hasUnsavedChanges, [initTabs['target_showcase']]: true };
    const has = hasUnsavedChanges[initTabs['target_showcase']];
    if (!has) {
      dispatch(setHasUnsavedChanges(hasChanges));
    }
  };
  const deleteRows = (type, deleteKeys) => {
    let newData = [...maxTargetShowcaseData];

    switch (type) {
      case 'single': {
        newData = deleteKeys[0] ? newData.filter((item) => item.key !== deleteKeys[0]) : newData;
        break;
      }
      case 'multiple': {
        newData = deleteKeys?.length
          ? newData.filter((item) => !deleteKeys.find((key) => key === item.key))
          : newData;
        setSelectedKeys([]);
      }
    }

    dispatch(setVisDeletedRow([]));
    dispatch(setTargetShowcaseData(newData));
    handleSetHasChanges();
  };
  const deleteRowVisible = (deletedRowKey) => {
    dispatch(setVisDeletedRow(deletedRowKey));
  };
  const showNotificationDeleteRow = (type, deleteKeys) => {
    const timer = setTimeout(() => {
      deleteRows(type, deleteKeys);
    }, 5000);

    const handleCancel = () => {
      deleteRowVisible([]);
      clearTimeout(timer);
      notification.destroy();
    };
    notification.info({
      message: 'Цепочка удалена',
      description: (
        <div>
          <Button onClick={handleCancel}>Отменить</Button>
        </div>
      ),
      duration: 5,
      placement: 'topLeft',
      closeIcon: <div style={{ display: 'none' }}></div>,
      onClose: () => handleCancel,
      // icon: getIconForNotification(status),
    });
  };
  const showXPathDrawer = (key) => {
    getProjectXPathStructure({ id: editableTable.id });
    setDrawerKey(key);
  };
  const buttonEventHandler = (type) => {
    setIsLoading(true);
    let deletedKeys = [];
    switch (type) {
      case 'single': {
        deletedKeys = [deleteUpdateBtns.key];
        break;
      }
      case 'multiple': {
        deletedKeys = selectedKeys;
        break;
      }
    }
    deleteRowVisible(deletedKeys);
    showNotificationDeleteRow(type, deletedKeys);
    setDeleteUpdateBtns({ y: null, key: null, isNew: false });
    setIsLoading(false);
  };
  const goToXpath = (xPathCode) => {
    // const params = { tableId: editableTable.id, code: xPathCode };
    const baseUrl = window.location.origin;
    const url = new URL(`${baseUrl}/projects/allProjects`);
    const tableId = editableTable.id?.toString();
    url.searchParams.set('editableTableKey', tableId);
    url.searchParams.set('code', xPathCode);
    window.open(url, '_blank');
  };
  const rowSelection = {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onChange: (selectedRowKeys: number[], selectedRows: IShowcase[]) => {
      setSelectedKeys(selectedRowKeys);
    },
    selectedRowKeys: selectedKeys,
  };
  //DEFAULT_COLUMNS
  const defaultColumns: (ColumnTypes[number] & { editable?: boolean; dataIndex: string })[] = [
    {
      title: '№',
      dataIndex: 'number',
      editable: true,
      width: 50,
    },
    {
      title: labelNames['englishName'],
      dataIndex: 'englishName',
      editable: true,
      render: (text) => {
        return (
          <div className={s.nameCol}>
            {text ? (
              <Tooltip placement='topLeft' title={text}>
                <div className={s.nameColContent}>{text}</div>
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
    {
      title: 'Название на русском',
      dataIndex: 'russianName',
      editable: true,
      render: (text) => {
        return (
          <div className={s.nameCol}>
            {text ? (
              <Tooltip placement='topLeft' title={text}>
                <div className={s.nameColContent}>{text}</div>
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
    {
      title: 'Тип атрибута',
      dataIndex: 'attributeType',
      editable: true,
      render: (text) => {
        // const label = text && (attributeTypeOptions || []).find(({ id }) => id === text)?.name;
        const label = text;
        return (
          <div className={s.nameCol}>
            {label ? (
              <Tooltip placement='top' title={label}>
                <div className={s.nameColContent}>{label}</div>
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
    {
      title: 'Комментарий',
      dataIndex: 'comment',
      editable: true,
      render: (text) => {
        return (
          <div className={s.nameCol}>
            {text ? (
              <Tooltip placement='topLeft' title={text}>
                <div className={s.nameColContent}>{text}</div>
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
    {
      title: 'xpath',
      dataIndex: 'xpath',
      width: 200,
      editable: true,
      render: (text, record) => {
        const currentLabel = xPathCodes.find((xPath) => xPath.value === text)?.label;
        const initialPathLabel = (
          <Tooltip placement='topLeft' title={currentLabel}>
            <div
              className={s.nameCol}
              style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}
            >
              <div className={s.nameColContent}>{currentLabel}</div>
              <div
                style={{ marginLeft: '12px', cursor: 'pointer' }}
                onClick={() => goToXpath(text)}
              >
                <ExportOutlined style={{ color: colorPrimary }} />
              </div>
            </div>
          </Tooltip>
        );
        if (record.description === initDescriptionNumber) {
          const labels = [];

          record?.args?.forEach((el) => {
            const label = xPathCodes.find((xPath) => xPath.value === el)?.label;
            labels.push(label);
          });

          let lab = 'Выберите xPath';
          if (text !== '-' && !labels.length) {
            return <div onClick={() => showXPathDrawer(record.key)}>{initialPathLabel}</div> || '-';
          }
          if (labels.length) {
            lab = labels.join(', ');
          }
          // const lab = text === '-' || !labels.length ? 'Выберите xPath' : labels.join(', ');
          const labelsNumb = labels.length ? ` +${labels.length}` : '';
          return (
            <Tooltip placement='topLeft' title={labels.join(', ')}>
              <div onClick={() => showXPathDrawer(record.key)} className={s.nameColContent}>
                {lab.slice(0, 14) + labelsNumb}
              </div>
            </Tooltip>
          );
        }
        return <div>{currentLabel ? initialPathLabel : '-'}</div>;
      },
    },
    {
      title: 'Описание обработки',
      dataIndex: 'description',
      editable: true,
      render: (text, record) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        let label = text && (descriptionTargetShowcase || []).find(({ id }) => id === text)?.name;
        if (text === 'custom') {
          label = 'Кастом';
        }
        if (text === initDescriptionNumber) {
          label = record.customComment || label;
        }
        return (
          <div className={s.nameCol}>
            {label ? (
              <Tooltip placement='top' title={label}>
                <div className={s.nameColContent}>{label}</div>
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
    {
      title: 'Результат xPath',
      dataIndex: 'result',
      // editable: true,
      render: (text) => {
        const tooltipText = (
          <ol>{Array.isArray(text) ? text.map((t, index) => <li key={index}>{t}</li>) : text}</ol>
        );
        const visText = Array.isArray(text) ? text[0].slice(0, 14) : text.slice(0, 14);
        return (
          <div className={s.nameCol}>
            {text ? (
              <Tooltip placement='topLeft' title={tooltipText}>
                <div className={s.nameColContent}>{visText}</div>
              </Tooltip>
            ) : (
              '-'
            )}
          </div>
        );
      },
    },
  ];
  const handleLoadRawXPath = () => {
    getProjectXPathStructure({ id: editableTable.id });
    setLoadRawXPath(true);
  };
  const handleAdd = () => {
    const numb =
      [...maxTargetShowcaseData].sort((a, b) => a.number - b.number)[
        maxTargetShowcaseData.length - 1
      ]?.number || 0;
    const newData: IShowcase = {
      key: generateUniqueID(),
      number: numb + 1,
      englishName: '-',
      russianName: '-',
      attributeType: initAttributeType,
      comment: '-',
      xpath: '-',
      description: initDescription,
      result: '-',
      transform_idr: '',
    };
    dispatch(setTargetShowcaseData([...maxTargetShowcaseData, newData]));

    setCount(count + 1);
    handleSetHasChanges();
  };
  const handleSave = (row: IShowcase) => {
    const newData = [...maxTargetShowcaseData];
    const transform_idr = (descriptionTargetShowcase || []).find(
      ({ code }) => code === row.description,
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
    )?.id;
    const index = newData.findIndex((item) => row.key === item.key);
    const item = newData[index];
    // setChangedRows([...changedRows, row.key]);
    newData.splice(index, 1, {
      ...item,
      ...row,
      transform_idr: transform_idr,
    });
    dispatch(setTargetShowcaseData(newData));
    handleSetHasChanges();
  };
  const currentTab = cdaRedactorTabs.find((tab) => tab.key === activeXmlTab) || cdaRedactorTabs[0];
  const handleUpdateTable = (key) => {
    setIsLoading(true);
    if (!currentTab?.code && !currentTab?.fileName) {
      showNotification(notification, notificationMessages.absentXml, ' ', 'error');
      setIsLoading(false);
      return;
    }
    const dataCheckAllXPath = getDataForCheckXPathTarget(
      maxTargetShowcaseData,
      maxData,
      currentTab?.fileName,
      key,
    );

    getCheckAllXPath(dataCheckAllXPath);
    // getTargetShowcaseData({ id: editableTable.id });
    setIsLoading(false);
  };
  const handleExportXlsxFile = () => {
    setIsLoading(true);
    const exportData = getCreateXlsxData(
      maxTargetShowcaseData,
      descriptionTargetShowcase || [],
      xPathCodes,
    );
    getXlsxFileInfo({ body: exportData, projectName: editableTable.project_name });
    setIsLoading(false);
  };
  const handleSearch = (text) => {
    setSearchedText(text);
  };
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };
  const descriptionOptions: Array<{ label: string; value: string }> = (
    descriptionTargetShowcase || []
  ).map((el) => ({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    label: el.name,
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    value: el.id,
  }));
  //COLUMNS
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col;
    }
    const data = [...maxTargetShowcaseData];
    const allEnNames = data.map((el) => el.englishName);
    const allNumbers = data.map((el) => el.number);
    return {
      ...col,
      onCell: (record: IShowcase) => {
        return {
          record,
          allEnNames,
          allNumbers,
          attributeTypeOptions: attributeTypeOptions || [],
          xPathOptions: xPathCodes,
          selectOptions: descriptionOptions,
          editable: col.editable,
          dataIndex: col.dataIndex,
          handleSave,
        };
      },
    };
  });

  let filteredData = maxTargetShowcaseData || [];
  if (searchedText) {
    filteredData = filteredData.filter((el) => {
      return (
        getInsensitiveTextSearch(el?.xpath, searchedText) ||
        getInsensitiveTextSearch(el?.englishName, searchedText) ||
        getInsensitiveTextSearch(el?.attributeType, searchedText) ||
        getInsensitiveTextSearch(el?.russianName, searchedText)
      );
    });
  }

  filteredData = [...filteredData].sort((a, b) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const aKey = typeof a.number === 'string' ? Number(a.number.replace('_new', '')) : a.number;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const bKey = typeof b.number === 'string' ? Number(b.number.replace('_new', '')) : b.number;
    return aKey - bKey;
  });

  const {
    parseXlsxError: parseXlsxErrorText,
    xPathStructureError,
    fileXlsxInfoError,
  } = getErrors({
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    fileInfoError,
    projectXPathStructureError,
    parseXlsxError,
  });
  useEffect(() => {
    if (fileInfoData && !fileInfoError && !fileInfoLoading) {
      getXlsxFile({ filename: fileInfoData.filename });
    }
    if (!fileInfoData && fileInfoError && !fileInfoLoading) {
      showNotification(
        notification,
        notificationMessages.errRespXPathProject,
        fileXlsxInfoError,
        'error',
      );
    }
  }, [fileInfoData, fileInfoError, fileInfoLoading]);
  useEffect(() => {
    if (targetShowcaseData) {
      const dataSource = getDataForTargetShowcase(targetShowcaseData, initDescription);
      dispatch(setTargetShowcaseData(dataSource));
    }
  }, [targetShowcaseData, targetShowcaseError, targetShowcaseLoading]);
  useEffect(() => {
    if (editableTable.id) {
      getProjectXPathStructure({ id: editableTable.id });
      getTargetShowcaseData({ id: editableTable.id });
    }
  }, [editableTable]);
  useEffect(() => {
    if (projectXPathStructureData && !projectXPathStructureLoading && !projectXPathStructureError) {
      const codesOptions = Array.isArray(projectXPathStructureData)
        ? getCodesOptions(projectXPathStructureData)
        : [];
      setXPathCodes(codesOptions);

      if (isLoadRawXPath) {
        const dataFromCDA = projectXPathStructureData || [];
        const dataFromCDAForTarget = getDataFromCDAForTarget(
          dataFromCDA,
          maxTargetShowcaseData,
          initDescription,
        );
        // dispatch(setTargetShowcaseData([...maxTargetShowcaseData, ...dataFromCDAForTarget]));
        dispatch(setTargetShowcaseData([...dataFromCDAForTarget]));
        setLoadRawXPath(false);
        handleSetHasChanges();
      }
    }

    if (projectXPathStructureError) {
      showNotification(
        notification,
        notificationMessages.errRespXPathProject,
        xPathStructureError,
        'error',
      );
    }
  }, [
    projectXPathStructureData,
    projectXPathStructureLoading,
    projectXPathStructureError,
    isLoadRawXPath,
  ]);
  useEffect(() => {
    if (checkAllXPathData && !checkAllXPathError && !checkAllXPathLoading) {
      const verificationXPathData = getVerificationXPathDataTarget(
        checkAllXPathData,
        maxTargetShowcaseData,
      );
      dispatch(setTargetShowcaseData(verificationXPathData));
    }

    if (!checkAllXPathData && checkAllXPathError && !checkAllXPathLoading) {
      showNotification(
        notification,
        notificationMessages.errRespXPathCheck,
        checkAllXPathError,
        'error',
      );
    }
  }, [checkAllXPathData, checkAllXPathError, checkAllXPathLoading]);
  useEffect(() => {
    //success
    if (parseXlsxData && !parseXlsxError && !parseXlsxLoading) {
      const normalData = getXlsxDataForTargetShowcase(parseXlsxData.data, []);
      dispatch(setTargetShowcaseData(normalData));
    }
    //err
    if (parseXlsxError && !parseXlsxData && !parseXlsxLoading) {
      showNotification(
        notification,
        parseXlsxErrorText || ' ',
        notificationMessages.errUploadXml,
        'error',
      );
    }
  }, [parseXlsxData, parseXlsxError, parseXlsxLoading]);
  return (
    <div className={s.TargetShowcase} style={{ position: 'relative' }}>
      <XPathStructureTarget
        structureData={projectXPathStructureData || []}
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        targetData={maxTargetShowcaseData || []}
        /* eslint-disable-next-line @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        handleSave={handleSave}
        setDrawerKey={setDrawerKey}
        drawerKey={drawerKey}
      />
      <Spin
        tip='Loading...'
        spinning={
          targetShowcaseLoading ||
          parseXlsxLoading ||
          fileInfoLoading ||
          checkAllXPathLoading ||
          isLoadRawXPath ||
          !!visDeletedRow.length ||
          isLoading
        }
        size='large'
      >
        <div className={s.content}>
          <Filters
            handleSearch={handleSearch}
            buttonEventHandler={buttonEventHandler}
            selectedKeys={selectedKeys}
            onUpdate={handleUpdateTable}
            handleExportXlsxFile={handleExportXlsxFile}
            handleLoadRawXPath={handleLoadRawXPath}
            exportProps={exportProps}
          />
          <div style={{ width: '100%', textAlign: 'right' }}>
            {currentTab?.label || 'Файл не выбран'}
          </div>

          <Table
            components={components}
            rowClassName={() => 'editable-row'}
            bordered
            dataSource={filteredData}
            columns={columns as ColumnTypes}
            pagination={false}
            onRow={(record) => {
              return {
                onMouseEnter: (event) => {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  const params = event?.target?.getBoundingClientRect();
                  const isNew =
                    (typeof record.key === 'string' && record.key.includes('_new')) ||
                    record.description === initDescriptionNumber;
                  setDeleteUpdateBtns({
                    y: params?.y + params.height / 6 || null,
                    key: record.key,
                    isNew: isNew,
                  });
                }, // mouse enter row
                onMouseLeave: (event) => {
                  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                  // @ts-ignore
                  if (!event.relatedTarget.classList?.contains('deleteBtn')) {
                    setDeleteUpdateBtns({ y: null, key: null, isNew: false });
                  }
                }, // mouse leave row
              };
            }}
            rowSelection={{ ...rowSelection }}
            size={'small'}
          />
          {deleteUpdateBtns?.y && !drawerKey ? (
            <div
              className={'deleteBtn'}
              style={{
                display: 'flex',
                gap: '8px',
                position: 'fixed',
                top: deleteUpdateBtns.y,
                right: 84,
                zIndex: 9999,
              }}
            >
              {!deleteUpdateBtns.isNew ? (
                <Button
                  type='primary'
                  size={'small'}
                  shape='circle'
                  icon={<ReloadOutlined />}
                  className={'deleteBtn'}
                  onClick={() => handleUpdateTable(deleteUpdateBtns.key)}
                ></Button>
              ) : (
                ''
              )}
              <Button
                size={'small'}
                type='primary'
                shape='circle'
                danger
                icon={<DeleteOutlined />}
                className={'deleteBtn'}
                onClick={() => buttonEventHandler('single')}
              ></Button>
            </div>
          ) : (
            ''
          )}
          <Button
            disabled={!!visDeletedRow.length}
            icon={<PlusCircleTwoTone twoToneColor={defaultData.colorPrimary} />}
            className={s.addRowBtn}
            onClick={handleAdd}
          >
            Добавить строку
          </Button>
        </div>
      </Spin>
    </div>
  );
};
